/**************************************************************************
 * ADOBE CONFIDENTIAL
 * ___________________
 *
 * Copyright 2021 Adobe
 * All Rights Reserved.
 *
 * NOTICE: All information contained herein is, and remains
 * the property of Adobe and its suppliers, if any. The intellectual
 * and technical concepts contained herein are proprietary to Adobe
 * and its suppliers and are protected by all applicable intellectual
 * property laws, including trade secret and copyright laws.
 * Dissemination of this information or reproduction of this material
 * is strictly forbidden unless prior written permission is obtained
 * from Adobe.
 ***************************************************************************/

const schemaFormat = /\d+\.\d+\.\d+(ce|ee)?/s;

const toSemanticSchemaVersion = stringSchema =>
    stringSchema.match(/(\d+|ce|ee)/g).map((v, i) => (i < 3 ? parseInt(v) : v));

export const compareSchemaVersions = (schema1, schema2) => {
    if (!schemaFormat.test(schema1) || !schemaFormat.test(schema2)) {
        throw new Error('Schema version format is invalid.');
    }

    const semanticSchema1 = toSemanticSchemaVersion(schema1);
    const semanticSchema2 = toSemanticSchemaVersion(schema2);

    return semanticSchema1.reduce((acc, v, i) => {
        if (acc !== 0) return acc;

        if (i < 3) {
            return v - semanticSchema2[i];
        }

        return v.localeCompare(semanticSchema2[i]);
    }, 0);
};
